import { Declaration } from 'store/declarations/declaration';
import { DeclarationStatuses } from 'store/declarations/enums/common/declaration-status';
import { ICS2TransactionType } from 'store/declarations/eu/ics2/ics2-notification';
import { isIcs2Notification } from './declaration-notifications/ics2/ics2NotificationUtils';

export const rejectedStatuses: DeclarationStatuses[] = [
    DeclarationStatuses.REJECTED,
    DeclarationStatuses.INVALID,
    DeclarationStatuses.DECLARATION_REJECTED,
    DeclarationStatuses.DECLARATION_REJECTED_AT_ARRIVAL,
    DeclarationStatuses.DIVERSION_REJECTED,
    DeclarationStatuses.ICS2_REJECTED,
];

// A rejected ICS2 amendment or invalidation leaves the ENS status as it was, so only the notification tells.
const ics2StatusPreservingTransactions: ICS2TransactionType[] = [
    ICS2TransactionType.AMENDMENT,
    ICS2TransactionType.INVALIDATE,
];

/**
 * The errors come from the latest notification. Once a declaration is resubmitted that is still the old rejection
 * until the authority answers, so the errors only count while the status is still rejected or invalid.
 */
const shouldShowNotificationErrors = (
    declaration: Declaration | undefined,
    errors: unknown[] | undefined,
    latestNotification?: unknown
): boolean => {
    const hasErrors = !!errors?.length;
    if (!declaration || !hasErrors) return false;

    const isIcs2AmendmentOrInvalidationRejection =
        isIcs2Notification(latestNotification) &&
        !!latestNotification.ics2TransactionType &&
        ics2StatusPreservingTransactions.includes(latestNotification.ics2TransactionType);
    if (isIcs2AmendmentOrInvalidationRejection) return true;

    return rejectedStatuses.includes(declaration.status);
};

export default shouldShowNotificationErrors;
